import { render, staticRenderFns } from "./MentorTable.vue?vue&type=template&id=a3e6395c&"
import script from "./MentorTable.vue?vue&type=script&lang=js&"
export * from "./MentorTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports